export const NAME_ROUTES = {
    HOME: { path: '/', name: 'home' },
    ITEM_DETAIL: { path: '/item/:id/:token', name: 'itemDetail' },
    ITEM_WITH_SINISTERS: { path: '/item/claims/:id/:token', name: 'itemWithSinisters' },
};
